import { useDisplayOptionContext } from "@/hooks/useDisplayOptionContext";
import { useFacilitiesContext } from "@/hooks/useFacilitiesContext";

export const useRateLabels = (facilityId: number | undefined) => {
    const { facilities = [] } = useFacilitiesContext();
    const { language = {} } = useDisplayOptionContext();

    const currentFacility = facilityId
        ? facilities.find((facility) => facility.id === facilityId)
        : undefined;

    return {
        promoRate:
            currentFacility?.rate_labels?.promoRate ||
            language?.grid?.promoRate ||
            "Promo Rate",
        webRate:
            currentFacility?.rate_labels?.webRate ||
            language?.grid?.webRate ||
            "Web Rate",
        strikeThroughRate:
            currentFacility?.rate_labels?.strikeThroughRate ||
            language?.grid?.strikeThroughRate ||
            "Starting at",
    };
};
